(function(window, document) {
    if (document.querySelector('.referencelist') !== null) {
        var brancheSelectElement = document.querySelector('.referencelist .referencelist-brancheselect');
        var technologySelectElement = document.querySelector('.referencelist .referencelist-technologyselect');
        var columns = parseInt(document.querySelector('.referencelist').getAttribute('data-columns'));
        var offset = parseInt(document.querySelector('.referencelist').getAttribute('data-offset'));
        var limit = parseInt(document.querySelector('.referencelist').getAttribute('data-limit'));
        var endlessScroll = parseInt(document.querySelector('.referencelist').getAttribute('data-endlessscroll')) === 1;
        var preDefinedReferences = document.querySelector('.referencelist').getAttribute('data-predefinedreferences');
        var preFilteredBranches = document.querySelector('.referencelist').getAttribute('data-prefilteredbranches');
        var preFilteredTechnologies = document.querySelector('.referencelist').getAttribute('data-prefilteredtechnologies');
        var hideSpecialReferences = parseInt(document.querySelector('.referencelist').getAttribute('data-hidespecialreferences')) === 1;
        var loading = false;

        /**
         * Load references
         */
        function loadReferences() {
            if (loading) {
                return;
            }
            loading = true;

            var branche = (brancheSelectElement !== null) ? brancheSelectElement.value : '';
            var technology = (technologySelectElement !== null) ? technologySelectElement.value : '';
            var url = window._AVENCY_BASE_actions.referenceList;
            url += branche !== '' ? '&branche=' + branche : '';
            url += technology !== '' ? '&technology=' + technology : '';
            url += preDefinedReferences !== '' ? '&preDefinedReferences=' + preDefinedReferences : '';
            url += preFilteredBranches !== '' ? '&preFilteredBranches=' + preFilteredBranches : '';
            url += preFilteredTechnologies !== '' ? '&preFilteredTechnologies=' + preFilteredTechnologies : '';
            url += '&hideSpecialReferences=' + (hideSpecialReferences ? '1' : '0');
            url += '&columns=' + columns;
            url += '&offset=' + offset;
            url += '&limit=' + limit;

            var request = new XMLHttpRequest();
            request.open('GET', url, true);
            request.onload = function () {
                if (this.status >= 200 && this.status < 400 && this.response != '') {
                    if (endlessScroll && offset > 0) {
                        var newDom = document.createElement('div');
                        newDom.innerHTML = this.response;
                        document.querySelector('.referencelist .referencelist-listing').appendChild(newDom);
                    } else {
                        document.querySelector('.referencelist .referencelist-listing').innerHTML = this.response;
                    }
                    loading = false;
                    offset += limit;

                    if (window.lazyLoadObject instanceof window.LazyLoad) {
                        window.lazyLoadObject.update();
                    }
                }
            };
            request.send();
        }

        /**
         * Check if reference bottom is in viewport
         */
        function isInViewport() {
            var endlessScrollElement = document.querySelector('.referencelist .referencelist-endlessscroll');
            var bounding = endlessScrollElement.getBoundingClientRect();
            return (
                bounding.top >= 0 &&
                bounding.left >= 0 &&
                bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
            );
        }

        // Load first batch of references
        loadReferences();

        if (brancheSelectElement !== null) {
            brancheSelectElement.addEventListener('change', function () {
                offset = 0;
                loading = false;
                loadReferences();
            });
        }
        if (technologySelectElement !== null) {
            technologySelectElement.addEventListener('change', function () {
                offset = 0;
                loading = false;
                loadReferences();
            });
        }

        if (endlessScroll) {
            window.addEventListener('scroll', function (event) {
                if (isInViewport()) {
                    loadReferences();
                }
            });
        }
    }
})(window, document);
